import { defineComponent as _defineComponent } from 'vue'
import CreateCourseButton from '@/ui/components/trainings/courses/CreateCourseButton.vue';
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';

export default /*#__PURE__*/_defineComponent({
  __name: 'ManageCoursesEmpty',
  setup(__props) {

  
return { __sfc: true,CreateCourseButton, EmptyStateEntry }
}

})